import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs';
import {CheckWalletLimitUseCase} from '../use-cases/check-wallet-limit.use-case';
import {CartTotalChangedEvent} from "@platform/event-bus/domain/events/cart/cart-total-changed.event";
import {EventBusPort} from "@platform/event-bus/domain/ports/event-bus.port";

@Injectable({providedIn: 'root'})
export class WalletOnCartTotalChangedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);
  private readonly updateLimitCheckUseCase = inject(CheckWalletLimitUseCase);

  constructor() {
    this.eventBus.ofType(CartTotalChangedEvent).pipe(
      tap(({payload}) => this.updateLimitCheckUseCase.execute(payload.newTotal)),
      takeUntilDestroyed(this.destroyRef),
    )
      .subscribe();
  }
}
